module.exports = __webpack_public_path__ + "img/4159.afbe2953.webp";